import { Component, Input } from '@angular/core';
import { ControlContainer } from '@angular/forms';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'contato-panel',
    templateUrl: './contato-panel.component.html',
    styleUrls: ['./contato-panel.component.scss']
})
export class ContatoPanelFormComponent {

    @Input() showHeader = false;

    constructor(
        public controlContainer: ControlContainer
    ) { }

}
